import dayjs from "dayjs";
import { disableDate } from "./shouldDisableDate";
import { OfflineDays, Service, ServiceAvailabilityException } from "types/entities";
import { CustomException } from "types/customException";

export const findClosestAvailableDate = (
	service: Service,
	offlineDays: OfflineDays[],
	offlineDaysByServices: { date: Date; service: Service }[],
    serviceAvailabilityException: ServiceAvailabilityException[],
) => {
	const startDate = service.startDate;

	//If the start date is greater than today, the starting date will be the start date
	//if not, it will be today
	let date =
		startDate >= new Date()
			? dayjs(startDate).startOf("day")
			: dayjs().startOf("day");

	const shouldDisableDate = disableDate(
		[service],
		offlineDays,
		offlineDaysByServices,
		serviceAvailabilityException
	);

	// Checking if the date is disabled, if it is, I will add one day to the selected date
	// until I find one date that is not disabled.
	while (shouldDisableDate(date)) {
		//If every service has an end date and it is less than the current date, I will show an error
		if (
			service.endDate !== null &&
			service.endDate.getTime() <= date.toDate().getTime()
		) {
            throw new CustomException("Lo sentimos, no hay fechas disponibles para el servicio seleccionado. Por favor, intente con otro servicio o verifique más tarde.", 500, "findTable.dateNotFound");
		}
		date = date.add(1, "day");
	}
    
    return date;
};
